"use client";

import Link from "next/link";

export default function SellPageTermsSummary() {
  return (
    <div className="bg-secondary p-4 rounded-lg">
      <h3 className="font-medium mb-2">Quick summary of terms</h3>
      <ul className="space-y-2 text-sm">
        <li className="flex items-start">
          <span className="text-primary mr-2" aria-hidden>
            ✓
          </span>
          You own this item and can legally sell it
        </li>
        <li className="flex items-start">
          <span className="text-primary mr-2" aria-hidden>
            ✓
          </span>
          All information provided is accurate
        </li>
        <li className="flex items-start">
          <span className="text-primary mr-2" aria-hidden>
            ✓
          </span>
          You&apos;ll respond to buyers within 24 hours
        </li>
        <li className="flex items-start">
          <span className="text-primary mr-2" aria-hidden>
            ✓
          </span>
          Sell It Off charges 10% on successful sales
        </li>
      </ul>
      <Link href="/terms" className="text-sm text-blue-500 mt-4 inline-block">
        Read full terms
      </Link>
    </div>
  );
}
